export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const SIGNUP = 'signup'
export const FORGOTPASSWORD = 'forgotPassword'

export const UPDATE_USER = 'updateUser'
export const REFRESH_USER = 'refreshUser'
export const UPDATE_USERSETTINGS = 'updateUserSettings'

export const FETCH_PROCESS = 'fetchProcess'
export const FETCH_PROCESSES = 'fetchProcesses'
export const UPDATE_PROCESS = 'updateProcess'
export const CREATE_PROCESS = 'createProcess'
export const DELETE_PROCESS = 'deleteProcess'

export const FETCH_ITEM = 'fetchItem'
export const FETCH_ITEMS = 'fetchItems'
export const UPDATE_ITEM = 'updateItem'
export const CREATE_ITEM = 'createItem'
export const DELETE_ITEM = 'deleteItem'
